<h1 mat-dialog-title></h1>

<div mat-dialog-content>
  <div class="note" *ngIf="showMessage">
    NOTE: YOU HAVE UNsaveD CHANGES, CLICK save & VIEW TO SEE THE LATEST DATA
    INCLUDED IN YOUR REPORT.
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="button_small cancel">
    cancel
  </button>
  <button
    mat-button
    *ngIf="!showMessage"
    (click)="onConfirmClick()"
    class="button_small"
    tabindex="-1"
  >
    VIEW
  </button>
  <button
    mat-button
    *ngIf="showMessage"
    (click)="saveAndView()"
    class="button_small"
    tabindex="-1"
  >
    save & VIEW
  </button>
</div>
